import { useState } from "react";
import QuoteFormTab from "../../../pages/get_a_quotepage/QuoteFormTab";
import ShipmentInfoModal from "./ShipmentInfoModal";

export default function CreateShipmentUI() {


 

	const content = (
		<section>
			{/* create shipment form  & map */}
			<section className="w-[95%]  mx-auto flex  flex-col  justify-center  items-center   gap-[1rem]  ">
				<div className="w-[95%]  mx-auto  ">
					<QuoteFormTab />
				</div>
				{/* <div className="w-[50%]">
					<h1>the header</h1>
					<p>
						Lorem ipsum dolor sit amet consectetur, adipisicing elit. Libero
						dolores cumque, aspernatur vero, perspiciatis quidem ipsum
						cupiditate voluptatibus distinctio molestias, doloribus sunt. Ex,
						illum ipsa voluptate nemo repellat labore distinctio nostrum ipsam
						ad! Omnis minima delectus atque dolorem perferendis commodi enim
						modi, voluptatem, sint quaerat natus ratione magni veniam, porro
						beatae quod voluptate soluta dicta dolore aspernatur! Corrupti qui,
						expedita aspernatur nam vero quibusdam nisi dolor dolorem esse,
						error cupiditate reiciendis fugit consequuntur libero voluptate
						impedit nemo? Voluptatum consequatur molestiae quo minima odio,
						similique corrupti dolorum numquam, voluptates quam eum assumenda
						ducimus explicabo. Commodi impedit laudantium assumenda at aliquam
						facilis.
					</p>
				</div> */}
			</section>
		</section>
	);

	return content;
}
